import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { AttributeLabelPipe } from '@df/ui/common/attribute-label.pipe';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ActionComponent } from '../ui/api/action.component';
import { ResultComponent } from '../ui/api/result.component';
import { BasketItemAbstract } from './basket-item.abstract';
import { ItemQtyComponent } from './item-qty.component';

@Component({
    selector: 'checkout-minibasket-item',
    templateUrl: './checkout-minibasket-item.html',
    standalone: true,
    imports: [
        ActionComponent,
        AttributeLabelPipe,
        CommonModule,
        DfImageDirective,
        ItemQtyComponent,
        OptionLabelPipe,
        PriceComponent,
        ResultComponent,
        RouterModule,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutMinibasketItemComponent extends BasketItemAbstract {}
